import React from 'react';
import { withRouter } from 'react-router';

import {func} from 'prop-types';

import ActionsPanelItem from '../../components/ActionsPanelItem';

import classes from './ActionInsert.module.css';

const SiteActionInsert = ({
    companyInfo,
    node,
    onToggleCreateAreaModal,
    onToggleCreateEquipmentModal,
    onToggleCreateSystemModal,
    onToggleDeleteSiteModal,
    onToggleEditSiteModal,
    setTargetSite,
    ...props
}) => {

    const handleWizard = () => {
        setTargetSite(node.id);

        props.history.push(`/architect/wizard?company=${companyInfo.companyId}`);
    };

    return (
        <div className={classes.agentActions}>
            <ActionsPanelItem
                title="Edit Site Information"
                iconUrl="/assets/images/siteTreeIcon.svg"
                onClick={() => onToggleEditSiteModal(true)}
            />
            <ActionsPanelItem
                title="Delete Site"
                iconUrl="/assets/images/deleteIconColor.svg"
                onClick={() => onToggleDeleteSiteModal(true)}
            />
            <ActionsPanelItem
                title="Create a new Area"
                iconUrl="/assets/images/areaTreeIcon.svg"
                onClick={() => onToggleCreateAreaModal(true)}
            />
            <ActionsPanelItem
                title="Create a new Equipment"
                iconUrl="/assets/images/equipmentTreeIcon.svg"
                onClick={() => onToggleCreateEquipmentModal(true)}
            />
            <ActionsPanelItem
                title="Create a new System"
                iconUrl="/assets/images/systemTreeIcon.svg"
                onClick={() => onToggleCreateSystemModal(true)}
            />
            <ActionsPanelItem
                title="Run Architect Wizard"
                iconUrl="/assets/images/enhanceIconFlat.svg"
                onClick={handleWizard}
            />
        </div>
    );
};


SiteActionInsert.defaultProps = {
    onToggleDeleteSiteModal: () => {}
};

SiteActionInsert.propTypes = {
    onToggleDeleteSiteModal: func
};

export default withRouter(SiteActionInsert);
